export default __webpack_public_path__ + "static/B0226-def73adc50fe5938d91b35b22381dbe1.png";